<button mat-icon-button class="go-to-top" #goToTopRef>
    <mat-icon (click)="goToTop()">keyboard_arrow_up</mat-icon>
</button>
